












import { Vue, Component, Mixins } from "vue-property-decorator";

@Component
export default class extends Mixins() {
  latestUpgrade: any[] = [];
  loading: boolean = false;

  async loadLatestUpgrade() {
    this.loading = true;
    const res = await this.$store.dispatch("statistics/latestUpgrade", {});
    if (res && res.Data && res.Data !== "{}") {
      this.latestUpgrade = res.Data;
    }
    this.loading = false;
  }

  mounted() {
    this.loadLatestUpgrade();
  }
}
